// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.claims.RentalManagerUserClaimWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserClaimWebApiHandler_add,
  RentalManagerUserClaimWebApiHandler_delete,
  RentalManagerUserClaimWebApiHandler_deleteAllUnverified,
  RentalManagerUserClaimWebApiHandler_getExclusiveProperties,
  RentalManagerUserClaimWebApiHandler_getExclusiveProperties_Path,
  RentalManagerUserClaimWebApiHandler_getExclusivePropertiesForAllUnverified,
  RentalManagerUserClaimWebApiHandler_getExclusivePropertiesForAllUnverified_Path,
  RentalManagerUserClaimWebApiHandler_list,
  RentalManagerUserClaimWebApiHandler_list_Path,
  RentalManagerUserClaimWebApiHandler_propertyLookup,
  RentalManagerUserClaimWebApiHandler_propertyLookup_Path,
  RentalManagerUserClaimWebApiHandler_propertyLookupAll,
  RentalManagerUserClaimWebApiHandler_propertyLookupAll_Path,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

import type {
  RentalManagerUserClaimType,
  UserClaimAddResponseWebDto,
  UserClaimGetExclusivePropertiesForAllUnverifiedWebDto,
  UserClaimGetExclusivePropertiesResponseWebDto,
  UserClaimListResponseWebDto,
  UserClaimPropertyLookupAllResponseWebDto,
  UserClaimPropertyLookupResponseWebDto,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

interface AddParams {
  type: RentalManagerUserClaimType;
  value: string;
}
interface DeleteParams {
  type: RentalManagerUserClaimType;
  value: string;
}
interface GetExclusivePropertiesParams {
  limit?: number;
  type: RentalManagerUserClaimType;
  value: string;
}
interface GetExclusivePropertiesForAllUnverifiedParams {
  limit?: number;
}
interface PropertyLookupParams {
  limit?: number;
  type: RentalManagerUserClaimType;
  value: string;
}
interface PropertyLookupAllParams {
  includeUnverified?: boolean;
  includeVerified?: boolean;
  limit?: number;
}

export interface RentalManagerUserClaimWebApiHandler_add_Args {
  getParams: AddParams;
}

export type RentalManagerUserClaimWebApiHandler_add_Options = UseMutationOptions<
  UserClaimAddResponseWebDto,
  unknown,
  RentalManagerUserClaimWebApiHandler_add_Args
>;

/**
 * Add a new contact method
 */
export const useRentalManagerUserClaimWebApiHandler_add = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserClaimWebApiHandler_add_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserClaimWebApiHandler_add_Args) =>
      RentalManagerUserClaimWebApiHandler_add(args.getParams, httpClient),
  });
};

export interface RentalManagerUserClaimWebApiHandler_delete_Args {
  getParams: DeleteParams;
}

export type RentalManagerUserClaimWebApiHandler_delete_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserClaimWebApiHandler_delete_Args
>;

/**
 * Delete a contact method
 */
export const useRentalManagerUserClaimWebApiHandler_delete = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserClaimWebApiHandler_delete_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserClaimWebApiHandler_delete_Args) =>
      RentalManagerUserClaimWebApiHandler_delete(args.getParams, httpClient),
  });
};

export type RentalManagerUserClaimWebApiHandler_deleteAllUnverified_Options = UseMutationOptions<void, unknown, void>;

/**
 * Delete all unverified contact methods
 */
export const useRentalManagerUserClaimWebApiHandler_deleteAllUnverified = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserClaimWebApiHandler_deleteAllUnverified_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: () => RentalManagerUserClaimWebApiHandler_deleteAllUnverified(httpClient),
  });
};

export type RentalManagerUserClaimWebApiHandler_getExclusiveProperties_Options = UseQueryOptions<
  UserClaimGetExclusivePropertiesResponseWebDto,
  unknown,
  UserClaimGetExclusivePropertiesResponseWebDto,
  readonly [string, GetExclusivePropertiesParams]
>;

const RentalManagerUserClaimWebApiHandler_getExclusiveProperties_GetKey = (getParams: GetExclusivePropertiesParams) =>
  [RentalManagerUserClaimWebApiHandler_getExclusiveProperties_Path, getParams] as const;

export const RentalManagerUserClaimWebApiHandler_getExclusiveProperties_queryOptions = (
  getParams: GetExclusivePropertiesParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserClaimWebApiHandler_getExclusiveProperties_GetKey(getParams),
    queryFn: () => RentalManagerUserClaimWebApiHandler_getExclusiveProperties(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Retrieve listings that are exclusive to the given contact method
 */
export const useRentalManagerUserClaimWebApiHandler_getExclusiveProperties = (
  getParams: GetExclusivePropertiesParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserClaimWebApiHandler_getExclusiveProperties_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserClaimWebApiHandler_getExclusiveProperties_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserClaimWebApiHandler_getExclusiveProperties.getKey =
  RentalManagerUserClaimWebApiHandler_getExclusiveProperties_GetKey;

export type RentalManagerUserClaimWebApiHandler_getExclusivePropertiesForAllUnverified_Options = UseQueryOptions<
  UserClaimGetExclusivePropertiesForAllUnverifiedWebDto,
  unknown,
  UserClaimGetExclusivePropertiesForAllUnverifiedWebDto,
  readonly [string, GetExclusivePropertiesForAllUnverifiedParams]
>;

const RentalManagerUserClaimWebApiHandler_getExclusivePropertiesForAllUnverified_GetKey = (
  getParams: GetExclusivePropertiesForAllUnverifiedParams,
) => [RentalManagerUserClaimWebApiHandler_getExclusivePropertiesForAllUnverified_Path, getParams] as const;

export const RentalManagerUserClaimWebApiHandler_getExclusivePropertiesForAllUnverified_queryOptions = (
  getParams: GetExclusivePropertiesForAllUnverifiedParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserClaimWebApiHandler_getExclusivePropertiesForAllUnverified_GetKey(getParams),
    queryFn: () => RentalManagerUserClaimWebApiHandler_getExclusivePropertiesForAllUnverified(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Retrieve listings that are exclusive to all the user's unverified contact methods
 */
export const useRentalManagerUserClaimWebApiHandler_getExclusivePropertiesForAllUnverified = (
  getParams: GetExclusivePropertiesForAllUnverifiedParams,
  {
    httpClient,
    ...options
  }: Omit<
    RentalManagerUserClaimWebApiHandler_getExclusivePropertiesForAllUnverified_Options,
    'queryFn' | 'queryKey'
  > & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...RentalManagerUserClaimWebApiHandler_getExclusivePropertiesForAllUnverified_queryOptions(getParams, {
      httpClient,
    }),
    ...options,
  });
};
useRentalManagerUserClaimWebApiHandler_getExclusivePropertiesForAllUnverified.getKey =
  RentalManagerUserClaimWebApiHandler_getExclusivePropertiesForAllUnverified_GetKey;

export type RentalManagerUserClaimWebApiHandler_list_Options = UseQueryOptions<
  UserClaimListResponseWebDto,
  unknown,
  UserClaimListResponseWebDto,
  readonly [string]
>;

const RentalManagerUserClaimWebApiHandler_list_GetKey = () => [RentalManagerUserClaimWebApiHandler_list_Path] as const;

export const RentalManagerUserClaimWebApiHandler_list_queryOptions = ({ httpClient }: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserClaimWebApiHandler_list_GetKey(),
    queryFn: () => RentalManagerUserClaimWebApiHandler_list(httpClient),
  }) as const satisfies QueryOptions;

/**
 * List all user's contact methods
 */
export const useRentalManagerUserClaimWebApiHandler_list = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserClaimWebApiHandler_list_Options, 'queryFn' | 'queryKey'> & { httpClient?: Client } = {}) => {
  return useQuery({
    ...RentalManagerUserClaimWebApiHandler_list_queryOptions({ httpClient }),
    ...options,
  });
};
useRentalManagerUserClaimWebApiHandler_list.getKey = RentalManagerUserClaimWebApiHandler_list_GetKey;

export type RentalManagerUserClaimWebApiHandler_propertyLookup_Options = UseQueryOptions<
  UserClaimPropertyLookupResponseWebDto,
  unknown,
  UserClaimPropertyLookupResponseWebDto,
  readonly [string, PropertyLookupParams]
>;

const RentalManagerUserClaimWebApiHandler_propertyLookup_GetKey = (getParams: PropertyLookupParams) =>
  [RentalManagerUserClaimWebApiHandler_propertyLookup_Path, getParams] as const;

export const RentalManagerUserClaimWebApiHandler_propertyLookup_queryOptions = (
  getParams: PropertyLookupParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserClaimWebApiHandler_propertyLookup_GetKey(getParams),
    queryFn: () => RentalManagerUserClaimWebApiHandler_propertyLookup(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Lookup properties by email or phone
 */
export const useRentalManagerUserClaimWebApiHandler_propertyLookup = (
  getParams: PropertyLookupParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserClaimWebApiHandler_propertyLookup_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserClaimWebApiHandler_propertyLookup_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserClaimWebApiHandler_propertyLookup.getKey =
  RentalManagerUserClaimWebApiHandler_propertyLookup_GetKey;

export type RentalManagerUserClaimWebApiHandler_propertyLookupAll_Options = UseQueryOptions<
  UserClaimPropertyLookupAllResponseWebDto,
  unknown,
  UserClaimPropertyLookupAllResponseWebDto,
  readonly [string, PropertyLookupAllParams]
>;

const RentalManagerUserClaimWebApiHandler_propertyLookupAll_GetKey = (getParams: PropertyLookupAllParams) =>
  [RentalManagerUserClaimWebApiHandler_propertyLookupAll_Path, getParams] as const;

export const RentalManagerUserClaimWebApiHandler_propertyLookupAll_queryOptions = (
  getParams: PropertyLookupAllParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserClaimWebApiHandler_propertyLookupAll_GetKey(getParams),
    queryFn: () => RentalManagerUserClaimWebApiHandler_propertyLookupAll(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Lookup properties by all additional contact methods
 */
export const useRentalManagerUserClaimWebApiHandler_propertyLookupAll = (
  getParams: PropertyLookupAllParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserClaimWebApiHandler_propertyLookupAll_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserClaimWebApiHandler_propertyLookupAll_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserClaimWebApiHandler_propertyLookupAll.getKey =
  RentalManagerUserClaimWebApiHandler_propertyLookupAll_GetKey;
